import React from 'react';

const SimpleLoader = () => {
    return <p className='dark:text-white text-center'>Loading...</p>;
}

export default SimpleLoader;